import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/core";
import { PADDING_X_MM } from "../constants";

export const HeaderImage = Node.create({
    name: "headerImage",
    draggable: false,

    addAttributes() {
        return {
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
        };
    },

    addOptions() {
        return {
            src: "",
        };
    },

    parseHTML() {
        return [
            {
                tag: 'img[src][data-type="header-image"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "img",
            mergeAttributes(HTMLAttributes, {
                "data-type": "header-image",
                src: this.options.src,
                draggable: "false",
                class: "header-image",
                style: `height: 100%; object-fit: contain; margin-left: -${PADDING_X_MM}mm`,
                alt: "Header logo",
            }),
        ];
    },
});
